import { Theme } from '@/theme'

import handle from './Handle.vue'
import label from './Label.vue'
import beforeChildren from './BeforeChildren.vue'

export default {
  handle,
  label,
  beforeChildren
} as Theme



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/theme/font-awesome/index.ts